module.exports = __webpack_public_path__ + "static/media/ARI-STEVI Pro 470-471.a325b813.jpg";